var MessageCh = {


  NavabarText: {

    navbar_about: "关于我们",

    navbar_item: "基因检测",
    navbar_search: "报告查询",
    navbar_searchy: "母血筛选报告查询",
    navbar_searchys: "叶酸代谢基因测试报告",

    navbar_contact: "联络我们",

    navbar_newinformation: "最新消息",

    navbr_jiyin: '基因天地',

    banner_text_tip: "检测服务与技术",


  },

  indexText: {

    more: "了解更多",

  },

  ContractText: {

    company_full_name: "香港卓信医疗化验所有限公司",

    // company_address: "香港新界火炭禾盛街11号中建电讯大厦8楼01室",

    company_address: "香港新界火炭坳背灣街2-12號威力工業中心9樓S室",

    address: "地址",

    tel: "电话",

    fax: "传真",

    email: "邮箱",

    web: "网址",

    quickContactYou: '我们的客服代表将尽快与您联系',
    namemust: '姓名 (必须)',
    phonemust: '电话 (必须)',
    emailmust: '电邮 (必须)',
    topic: '主题',
    content: '留言',


    mailbox_title: "咨询信箱",

    mailbox_subtitle: "【点击申请加盟】",

    mailbox_type: "咨询类型",

    mailbox_type_1: "顾客咨询",

    mailbox_type_2: "合作咨询",

    mailbox_sex_mr: "先生",

    mailbox_sex_mrs: "女士",

    mailbox_sex_lady: "夫人",

    mailbox_surname: "姓氏",

    mailbox_tel_phone: "联系电话：",

    mailbox_email: "电子信箱：",

    mailbox_message: "留言内容：",

    mailbox_btn: "确认",

    code: "证件号码",
    labno: "样本编号",

    name: "受测者姓名",

    phone: "电话号码",

    vertify: "验证码",

    vertifys: "验证码",

    send_sms: "发送验证码",

    send_sms_second: '再次发送',

    vertify_placeholder: "请输入验证码",

    phone_placeholder: "请输入手机号",


    tech_title: '我们的合作伙伴',

    medical: '医疗机构',

    physical: '体检中心',

    individual: '个人',

    organization: '非盈利机构',

    doctor: '医生',

    warning: '本人已阅读及同意网站的',

    private: '私隱政策',

    speaker: '语音验证',

    report_search_description: '母血筛查报告查询指引：',

    description_one: '报告查询功能于化验所发送报告后的第二天12:00提供。',

    description_two: '请确保您输入的受测者名字及样本编号与收到的报告一致。',

    description_three: '根据指引输入手机号码，点击“发送验证码”，您将收到5位数字的短信验证码。',

    description_four: '输入短信验证码，点击“确认”，您将成功查询到报告。',

    description_five: '若未收到短信验证码，请尝试“语音验证”。',

    report_search_descriptionys: '叶酸代谢基因测试报告查询指引：',

    description_oneys: '报告查询功能于化验所发送报告后的第二天12:00提供。',

    description_twoys: '请确保您输入的受测者名字及样本编号与收到的报告一致。',

    description_threeys: '根据指引输入手机号码，点击“发送验证码”，您将收到5位数字的短信验证码。',

    description_fourys: '输入短信验证码，点击“确认”，您将成功查询到报告。',

    description_fiveys: '若未收到短信验证码，请尝试“语音验证”。',

    verson: "版权所有",

    termsofuse: '使用条款',

    privacypolicy: '私隐政策',

    addressfoot: '香港新界火炭坳背灣街2-12號威力工業中心9樓S室',

    servicetime: '营业时间',

    TestingService: '检测服务',

    CompanyName: '香港卓信医疗化验所',

    newinfo: '最新消息',

    aboutus: '关于我们',

    GeneUniverse: '基因天地',

    ContactUs: '联络我们',

    weeks: '星期一至五',

    saturday: '星期六',

    holidays: '星期日及公众假期休息',

    Y_chromosome: 'Y-染色体母血筛选',

    PrenatalTesting: '无创产前检测',

    CancerReal: '癌症实时监控',

    Prenatal_Paternity_Testing: '无创产前亲子鉴定',

    genetic_tumor: '遗传性肿瘤检测',

    genetesting: '天赋基因检测',

    Thalassemia: '地中海贫血基因检测',

    Detection_diseases: '单基因遗传病检测',

    Vaccine: '疫苗抗体检测',

    aboutzhouxin: '关于卓信',

    technology: '科研技术',

    qualification: '资质及殊荣',

    mediacenter: '媒体中心',

    cooperation: '合作',

    recruitment: '人才招募',

    reproductivehealth: '生育健康',

    Y_chromosome_maternal_blood: 'Y-染色体母血筛选',

    Noninvasiveprenataltesting: '无创产前检测',

    Noninvasive_prenatal_paternity_test: '无创产前亲子鉴定',

    Paternity_testing: '亲子鉴定',

    Fragile_X_syndrome_screening: '脆性X综合症筛查',

    Detection_of_monogenic_genetic_diseases: '单基因遗传病检测',

    cancer: '癌症',

    Genetic_tumor_detection: '遗传性肿瘤检测',

    Cancer_real_time_monitoring: '癌症实时监控',

    Infectious_diseases: '传染病',

    Vaccine_antibody_test: '疫苗抗体检测',

    STD_quick_test: '性病快速测试',

    Talent_gene_testing: '天赋基因检测',

    Noninvasive_prenatal_testing: '无创产前检测',

    Health_and_disease_risk: '健康与疾病风险',

    Yreport: '母血筛查报告',

    MTHFRreport: '叶酸代谢基因测试报告',

  },

  GensUniverseText: {

    gens_tip_1: '无免疫力孕妇的患麻疹最严重可流产',

    gens_content_1: '本港今年年初发生的麻疹疫情非常严重,虽然现在情况可说是受到控制,但各界也不能掉以轻心。',


    gens_tip_2: '无入侵性抽血验癌症适宜年老病人',

    gens_content_2: '每当谈到癌症检验,活组织抽检往往令不少人却步,不过现今医学发展迅速,检测癌症可用非入侵性方式,而且这项技术愈趋成熟,令风险及成本降低,让更多人受惠。',


    gens_tip_3: '最易被忽略的一种过敏食物',

    gens_content_3: '好多家长都话小朋友有食物过敏,情况有几普遍？大家对幼儿食物过敏的认知有多少？',


    gens_tip_4: '乐观女性生仔机会较大',

    gens_content_4: '英国一项研究发现,性格乐观和生活较轻松的女性,怀孕时生男孩的机会较大,建议想生男婴的女性更要保持心境开朗及良好体格。',


    gens_tip_5: '双胞胎儿竟然是同母异父',

    gens_content_5: '福建省厦门市一对夫妻因为要帮双胞胎儿子报户口,所以去做亲子鉴定,没想到结果显示,双胞胎竟是「同母异父」兄弟！',


    gens_tip_6: '研究证实NIPT检测范围扩展至染色体微片段缺失重复是临床迫切的需求',

    gens_content_6: '随着临床数据的不断累积和分析技术的精进,非侵入性产前检测（NIPT）的临床应用未来势必更加广泛,这也将会是孕妇与胎儿的一大福音。',


    gens_tip_7: '全方位癌症基因分析突破无药可治的困局',

    gens_content_7: '就某些癌症而言,如肺癌和乳癌,基因检测的结果会直接影响治疗方案,故医生一般会在确诊的同时建议患者进行基因检测,把握时间,及早开始用「对」的药。',


    gens_tip_8: '接种了问题疫苗身体还会产生抗体吗？',

    gens_content_8: '屡次发生的疫苗事件令父母们忧心重重,对疫苗的效力完全失去信心,不少家长就设法为小朋友检测抗体,希望确定之前所注射的疫苗是有产生足够抗体来保护小朋友。',


    gens_tip_9: '基因如何影响天赋潜能？',

    gens_content_9: '天赋基因检测报告中判断孩子相关天赋的依据是什么？',


    gens_tip_10: '邵逸夫奖得奖科学家预计中国女性患乳腺癌的风险将持续上升',

    gens_content_10: '乳癌是本港女性最常见的癌症。一位科学家就预计在中国及香港,患上乳腺癌的女性只会有增无减。',


    gens_tip_11: '消失中的唐氏综合症香港孕妇产检与中止怀孕现况',

    gens_content_11: '唐氏综合症在冰岛可能因产前检查与中止怀孕的关系消失,那在香港的情况又如何？',


    gens_tip_12: '追查遗传基因罕见疾病难隐身',

    gens_content_12: '遗传病可经由基因一代传一代,而遗传学专家就如侦探一样,可利用基因检测等技术,在婚前检查或产前检查阶段,尽力发掘潜藏的遗传密码,以减低病发率及相关并发症出现。',


    gens_tip_13: '中大完成二万人「血浆DNA」鼻咽癌筛查研究大幅推前癌症发现期数',

    gens_content_13: '香港中文大学最近完成一项涉及20,000人的研究,确定透过分析血浆内EB病毒DNA,便可在尚未有病征前及早诊断出鼻咽癌。',

  },
  HomeText: {
  //   BannerTip_1_1: '6',
  //   BannerTip_1_2: '週',
  //   BannerTip_1_3: '即',
  //   BannerTip_1_4: '可',
  //   BannerTip_1_5: '檢',
  //   BannerTip_1_6: '測',
  //   BannerTip_1_Left: 'Y-染色體母血篩選',
  //   BannerTip_1_Right: '最快當日出結果',

    BannerTip_2_1: '基',
    BannerTip_2_2: '因',
    BannerTip_2_3: '角',
    BannerTip_2_4: '度',
    BannerTip_2_5: '度',
    BannerTip_2_6: '身',
    BannerTip_2_7: '打',
    BannerTip_2_8: '造',
    BannerTip_2_Left: '天賦基因檢測選',
    BannerTip_2_Right: '掌握天賦潛能',

    BannerTip_3: '榮獲ISO9001國際品質認證',
    BannerTip_3_Left: '香港卓信醫療化驗所',
    BannerTip_3_Right: '因為卓越．值得信賴',
    BannerTip_4: '荣获「商界展关怀」殊荣',
    GeneticTests: "基因检测",
    GeneticButton: "检测项目",
    ReproductiveHealth: "为BB买衫、买鞋",
    ReproductiveHealth2: "更要给他买不到的健康",
    Cancer: "再早一点",
    Cancer2: "生命就再多一点可能性",
    InfectiousDisease: "保护自己",
    InfectiousDisease2: "也要保护你爱的人",
    HealthyLife: "了解更多人生故事",
    HealthyLife2: "开启全新的生活方式",
    GeneticTestsSubtitleButton: "了解更多",
    GeneticTestsSubtitle1: "卓越技术 拯救生命",
    GeneticTestsSubtitle1Detail: "强大的团队配搭全球领先的技术，",
    GeneticTestsSubtitle1Detail2: "让人们透过基因，掌控自己的健康状况。",
    GeneticTestsSubtitle2: "专业认可 值得信赖",
    GeneticTestsSubtitle2Detail: "作为香港持牌化验所，",
    GeneticTestsSubtitle2Detail2: "获得ISO国际认证，给客户更多信心。",
    ServingLocalClinics: "服务本地诊所",
    SamplesProcesses: "处理样本数目",
    LatestGeneticInformation: "最新基因资讯",
  },
  AboutFCLAB: {
    Title: "关于卓信",
    FirstChoiceMedicalLaboratory: "香港卓信医疗化验所",
    FirstChoiceMedicalLaboratoryDetail: "所谓「卓信」，因卓越而值得信赖。",
    FirstChoiceMedicalLaboratoryDetail2: "更高质素的基因检测技术，更方便快捷的服务，是顾客的最佳选择。",
    Mission: "企业使命",
    MissionDetail: "结合创新的思维、崭新的基因检测技术，为顾客提供最专业和最精准的检测。",
    MissionDetail2: "开发和应用最新的遗传和基因组技术，让更多人意识到医疗保健的力量。",
    CoreCulture: "核心文化",
    Professional: "专业",
    ProfessionalDetail: "提供专业精准的DNA检测服务，使顾客受惠",
    Honest: "诚信",
    HonestDetail: "采用诚信的态度与客户沟通，建立彼此之间的信任",
  },

   // 新加FCLAB简介用于优化
   aboutFCLAB: {
    Title: "卓信化验所简介",
    FirstChoiceMedicalLaboratory: "公司简介",
    FirstChoiceMedicalLaboratoryDetail: "香港卓信医疗化验所有限公司，2017年10月27日成立于香港，公司编号2598283,主要提供基因检测服务。是香港少数获得ISO认证的医疗化验所。地址位于香港新界火炭坳背灣街2-12號威力工業中心9樓S室。 专业的一级医务化验师于香港医务化验师管理委员会注册，监管样本处理流程及签发化验报告。专注基因检测，提供无创产前检测、亲子鉴定、单基因遗传病、遗传性肿瘤检测、癌症实时监控、疫苗抗体检测、首创的genecode天赋基因检测等，受到客户信赖。",
    
    Mission: "产品服务",
    MissionDetail: "香港卓信医疗化验所有限公司专注基因检测，主要提供以下4大类基因检测 ",
    MissionDetail2: "生育健康",
    MissionDetail3: "无创产前检测、无创产前亲子鉴定、亲子鉴定、单基因遗传病等",
    MissionDetail4: "癌症",
    MissionDetail5: "遗传性肿瘤检测、癌症实时监控等 ",
    MissionDetail6: "传染病",
    MissionDetail7: "疫疫苗抗体检测，性病快速测试等 ",
    MissionDetail8: "天赋基因检测",
    MissionDetail9: "首创genecode天赋基因检测 ",
    MissionDetail10: "叶酸代谢基因检测",
    MissionDetail11: "通过对MTHFR基因其相关位点的检测，根据个人情况选择叶酸补充途径。(检测需时：1个工作日，支持网上查报告)",
    MissionDetail12: "公司理念",
    MissionDetail13: "因为卓越，所以值得信赖。",
    MissionDetail14: "更高质素的基因检测科技，更方便快捷的服务，成为顾客的最佳选择。",
    MissionDetail15: "公司使命",
    MissionDetail16: "结合创新的思维、崭新的基因检测科技，为顾客提供最专业和最精准的检测。",
    MissionDetail17: "开发和应用最新的遗传和基因组科技，让更多人意识到医疗保健的力量。",
    MissionDetail18: "发展历程",
    MissionDetail19: "2017年10月27日，香港卓信医疗化验所有限公司注册成立。",
    MissionDetail20: "香港卓信医疗化验所有限公司是一间专业的医疗化验所，专注基因检测及普及基因检测的应用，尤其生育及亲子健康方面。 ",
    MissionDetail21: "2018年，香港卓信医疗化验所成功通过BSI英国标准协会的审核，荣获ISO 9001:2015国际质量认证。",
    MissionDetail22: "于2020/21年获香港社会服务联会颁发“商界展关怀”殊荣。",
    MissionDetail23: "2019年，香港卓信医疗化验所有限公司成功自创品牌genecode，为顾客带来更全面、更准确的天赋基因检测。 ",
    MissionDetail24: "公司地址",
    MissionDetail25: "香港新界火炭坳背灣街2-12號威力工業中心9樓S室",
  },

  Technology: {
    Title: "科研技术",
    P1Title: "我们深明检测准确的重要性",
    P1Detail: "每项检测均为专业团队的成果",

    P2_1Title: "博士及硕士级科学家",
    P2_1Detail: "利用当代最新科技，研发及验证合乎国际标准的基因测试",
    P2_2Title: "注册一级医务化验师",
    P2_2Detail: "于香港医务化验师管理委员会注册，监管样本处理流程及签发化验报告",
    P2_3Title: "医生顾问",
    P2_3Detail: "根据现有的临床医学研究，提供有关资讯和意见",

    P3Title: "采用全球先进的DNA检测仪器分析每个样本",
    P3Detail: "检测试剂均由国外进口，受严格的品质监控",

    P4Title: "与国际知名化验所紧密合作",
    P4_1Detail: "梅奥医学实验室",
    P4_2Detail: "Natera",
    P4_3Detail: "路胜基因",
  },
  Accreditation: {
    Title: "资质及殊荣",
    P1Title: "香港认可的持牌化验所",
    P1Detail: "受香港医务化验师管理委员会严格监管",
    P1Button: "查看名单",

    P2Title: "香港少数获ISO认证化验所",
    P2Detail: "香港卓信医疗化验所成功通过BSI英国标准协会的审核，荣获ISO 9001:2015国际品质认证，标志着香港卓信医疗化验所在品质管理方面达到更高的水平，令您使用的服务得到国际水准的保证。",
    P2Detail2: "香港卓信医疗化验所一直努力建立一套专业化、标准化、制度化，并且符合国际标准的品质管理系统，好让客户得到最优质的医疗化验服务。本化验所获颁的ISO 9001:2015品质管理证书，正好印证了我们致力提供高质素服务的决心。",

    P3Title: "关于ISO 9001",
    P3Title2: "国际标准组织 | International Organization for Standardization (ISO)",
    P3Detail: "ISO 9001是一套国际通用的品质管理工具，标准由专家群在技术委员会内制订，用以维持企业提供之产品与服务的品质，确保品质一致性。技术委员会由工业界、非政府组织、政府和其他利益相关者的代表组成，成员由ISO成员提出。获得ISO 9001认证代表机构或组织通过严格的企业体系审核，达到国际认可的标准。",
    P3Detail2: "全新改版的ISO 9001:2015引入了风险思维的理念，加强关注公司的营运风险，同时考虑了当今不断变化的外围环境，以及协助公司应对客户日新月异的要求，提升企业竞争力。",

    P4Title: "荣获「商界展关怀」殊荣",
    P4Detail: "香港卓信医疗化验所实践良好企业公民精神，于2020/21年获香港社会服务联会颁发「商界展关怀」殊荣。我们会持续参与社会服务，为改善社会、改善环境继续努力。",

    P5Title: "关于绿色办公室奖励计划",
    P5Detail: "作为一家对社会有承担的企业，我们在实验室范围内进行改善工程，从日常工作流程至个人生活习惯入手，减少对环境造成影响，积极实践可持续发展的理念，并承诺继续为社会作出贡献。",
    
  },
  Media: {
    Title: "媒体中心",
    P1Title: "精准的基因检测 x 专业的医疗服务 ",
    P1_1Detail: "坚守品牌价值",
    P1_1Detail2: "报告严谨可信",
    P1_1Button: "报告查询",

    P1_2Detail: "汇集权威检测",
    P1_2Detail2: "行业领先资讯",
    P1_2Button: "基因天地",

    P1_3Detail: "绿色工作环境",
    P1_3Detail2: "承担企业责任",
    P1_3Button: "获奖证书",

    P1_4Detail: "配备先进仪器",
    P1_4Detail2: "资深技术人才",
    P1_4Button: "科研技术",

    P1_5Detail: "样本成千上万",
    P1_5Detail2: "严格监控品质 ",
    P1_5Button: "认证资质",

    P1_6Detail: "洞察商业脉搏",
    P1_6Detail2: "诚邀多方合作",
    P1_6Button: "合作",
  },
  Partnership: {
    Title: "合作",
    P1Title: "由于医务化验师《专业守则》第II章第6(c)节规定:",
    P1Detail: "医务化验师均不得在未有来自注册医生、牙医和／或兽医或根据香港法例第343 章诊疗所条例第8(1) 条豁免诊疗所注册人士的转介情况下，进行为医务诊断或治疗的任何化验。",
    P1Detail2: "香港卓信医疗化验所仅接受来自诊所医生转介的样本。如有关化验所的任何问题，欢迎来电(+852) 2865 9399咨询。",
  },
  Career: {
    Title: "人才招募",
    P1Title: "有意投身医疗化验行业？",
    P1Title2: "职责：",
    P1Title3: "资历：",
    P2Detail: "如欲申请上述空缺，请将履历电邮至hr@hkfirstchoice.com",
    P2Detail2: "（请注明申请职位）",
  },

  Cancerrealtime: {
    CancerReal_one: '及早发现癌症复发．掌握治疗黄金期',
    CancerReal_two: '以崭新ctDNA技术．随时掌握肿瘤动向',
    CancerReal_three: '什么是循环肿瘤DNA（ctDNA）？',
    CancerReal_four: '循环肿瘤DNA（Circulating Tumor DNA, ctDNA）是癌细胞坏死或凋亡后释放至血液中的DNA片段，带有重要的癌症基因变异资讯',
    CancerReal_five: '藉由监控ctDNA在血液中的动态变化，能够反应患者体内肿瘤的状况，及早侦测到癌症复发迹象。',
    CancerReal_six: '比传统方式更早侦出复发',
    CancerReal_seven: 'LiquidHALLMARK',
    CancerReal_f: ' 癌症实时监控',
    CancerReal_eight: '全球首个利用ctDNA技术，同时检测致癌基因突变和致癌病毒的血液测试。',
    CancerReal_nine: '由AmpliMARK™专利技术支持，可以检测极微量的ctDNA。',
    CancerReal_ten: '通过临床验证，为肿瘤科医生提供癌症治疗新方向。',
    CancerReal_eleven: '50种癌症基因',
    CancerReal_twelve: '包括多种标靶药相关基因，如EGFR（吉非替尼、奥希替尼）及ALK（克唑替尼）',
    CancerReal_threeteen: '6个微卫星不稳定性位点',
    CancerReal_fourteen: '决定可否选用免疫治疗',
    CancerReal_fiveteen: '2种致癌病毒',
    CancerReal_sixteen: '乙型肝炎病毒（HBV）及艾巴氏病毒（EBV）',
    CancerReal_seventeen: '4种基因变异',
    CancerReal_eighteen: '点突变、小型插入/缺失、基因扩增、基因融合',
    CancerReal_nineteen: '一次抽血监测14种癌症',
    CancerReal_twenty: '肺癌',
    CancerReal_twenty_one: '12种 癌症基因',
    CancerReal_twenty_two: '乳癌',
    CancerReal_twenty_three: '9种 癌症基因',
    CancerReal_twenty_four: '大肠癌',
    CancerReal_twenty_five: '11种 癌症基因',
    CancerReal_twenty_six: '肝癌',
    CancerReal_twenty_seven: '14种 癌症基因 +HBV病毒',
    CancerReal_twenty_eight: '鼻咽癌',
    CancerReal_twenty_nine: '7种 癌症基因 +EBV病毒',
    CancerReal_thirty: '胆管癌',
    CancerReal_thirty_one: '19种 癌症基因',
    CancerReal_thirty_two: '食道癌',
    CancerReal_thirty_three: '13种 癌症基因',
    CancerReal_thirty_four: '胃肠道间质瘤',
    CancerReal_thirty_five: '7种 癌症基因',
    CancerReal_thirty_six: '血癌（包括骨髓瘤）',
    CancerReal_thirty_eight: '10种 癌症基因',
    CancerReal_thirty_nine: '头颈部鳞状癌',
    CancerReal_fourty: '8种 癌症基因',
    CancerReal_fourty_one: '黑色素瘤',
    CancerReal_fourty_two: '14种 癌症基因',
    CancerReal_fourty_four: '胰脏癌',
    CancerReal_fourty_five: '8种 癌症基因',
    CancerReal_fourty_six: '泌尿上皮癌',
    CancerReal_fourty_seven: '8种 癌症基因',
    CancerReal_fourty_eight: '前列腺癌',
    CancerReal_fourty_nine: '6种 癌症基因',
    CancerReal_fifty: 'LiquidMARK',
    CancerReal_fifty_one: ' 可选择个别癌症定期监察。',
    CancerReal_fifty_two: '以上检测均包含6个微卫星不稳定性（MSI）位点。',
    CancerReal_fifty_three: 'LiquidHALLMARK',
    CancerReal_fuhao: '®',
    CancerReal_canhelp: ' 可幫您',
    CancerReal_fifty_four: '提供用药指导',
    CancerReal_fifty_five: '由于年老或肿瘤位置特殊等原因，部分癌症患者无法抽取肿瘤组织',
    CancerReal_fifty_six: 'ctDNA可帮助无法以手术或穿刺取得肿瘤组织的患者 提供用药指导建议。评估治疗效果',
    CancerReal_fifty_seven: '研究表明，癌症患者给予适当的治疗后，如有良好治疗效果，则侦测到的ctDNA量会明显下降',
    CancerReal_fifty_eight: '手术后在血液中检测不到ctDNA，患者预后较佳。',
    CancerReal_fifty_nine: '检测到ctDNA，预后相对较差，有更大机会复发。',
    CancerReal_sixty: '监控癌症复发',
    CancerReal_sixty_one: '研究表明，ctDNA的变化较影像检测早5.2个月发现癌症复发迹象',
    CancerReal_sixty_two: 'ctDNA可早期侦测到复发迹象，因此可藉由后续密集监控，帮助病人及早制定癌症治疗方案。',
    CancerReal_sixty_three: '追踪抗药性',
    CancerReal_sixty_four: '癌症病人使用某种药物一段时间后失效，其原因可能是来自于特定基因位点突变而导致抗药性',
    CancerReal_sixty_five: '利用ctDNA突变位点的侦测，可及早发现抗药性突变，调整适合的药物治疗策略。',
    CancerReal_sixty_six: '适用人群',
    CancerReal_sixty_eight: '常见问题',
    CancerReal_sixty_nine: 'LiquidHALLMARK',
    CancerReal_sixty_nine_end: ' 适用于健康人群的癌症早期筛查吗？',
    CancerReal_seventy: '不适用。本检测适用于已确诊癌症的患者，用于实时监控肿瘤动向，及早瞭解癌症复发迹象。',
    CancerReal_seventy_one: '我是否需要进行多次检测？',
    CancerReal_seventy_two: '本检测可提供密切关注，建议每6-12个月定期检测。您所需的具体检测次数取决于您的疾病阶段和治疗效果，由您的主诊医生判断。',
    CancerReal_seventy_three: '检测微卫星不稳定性（MSI）的意义何在？',
    CancerReal_seventy_four: '微卫星不稳定性（MSI）可用于预测免疫治疗的效果，帮助患者判断是否适合免疫治疗，避免花费高额治疗费用或错过治疗黄金期。',
    CancerReal_seventy_five: '参考文献',

  },

  Genetictumordetection: {
    Genetictumordetection_one: '癌症基因可遗传',
    Genetictumordetection_two: '高风险人群及早检测．预防胜于治疗',
    Genetictumordetection_three: '遗传性肿瘤基因变异会大幅增加罹癌风险',
    Genetictumordetection_four: '据统计，每年全球患癌新症数字约有1,750万，当中死亡人数高达870万。而癌症患者中，约5-10%是由遗传性基因变异引起的。如常见的BRCA1/2基因突变会使乳癌、卵巢癌1,2、大肠癌3及胃癌4等罹患风险大幅提高。',
    Genetictumordetection_five: '注册化验室签发报告',
    Genetictumordetection_fives: '您的家人曾罹癌癌症吗？',

    Genetictumordetection_six: '您曾经早于50岁罹患原位癌吗？',
    Genetictumordetection_seven: 'FCRisk™ 遗传性肿瘤基因检测',
    Genetictumordetection_eight: '提供详尽的基因资讯，可帮助医生评估相关癌症的罹患风险。',
    Genetictumordetection_nine: '为检测者日后的治疗与健康管理提供依据，让高风险人群可及早採取预防性措施。',
    Genetictumordetection_ten: '为不同性别提供两种套餐，男士套餐检测79个基因，合共评估16种遗传性肿瘤；女士套餐检测74个基因，合共评估17种遗传性肿瘤。',
    Genetictumordetection_eleven: '男士套餐',
    Genetictumordetection_twelve: '遗传性肿瘤',
    Genetictumordetection_threeteen: '女士套餐',
    Genetictumordetection_fourteen: '前列腺癌',
    Genetictumordetection_fiveteen: '乳腺癌',
    Genetictumordetection_sixteen: '卵巢癌',
    Genetictumordetection_seventeen: '子宫内膜癌',
    Genetictumordetection_eighteen: '大肠癌',
    Genetictumordetection_nineteen: '胃癌',
    Genetictumordetection_twenty: '肾癌',
    Genetictumordetection_twenty_one: '多发性内分泌腺瘤',
    Genetictumordetection_twenty_two: '甲状腺癌 ',
    Genetictumordetection_twenty_three: '甲状腺旁腺癌',
    Genetictumordetection_twenty_four: '多发性神经纤维瘤',
    Genetictumordetection_twenty_five: '嗜铬细胞瘤',
    Genetictumordetection_twenty_six: '家族性副神经节瘤',
    Genetictumordetection_twenty_seven: '视网膜母细胞瘤',
    Genetictumordetection_twenty_eight: '黑色素瘤',
    Genetictumordetection_twenty_nine: '多发性软骨肉瘤',
    Genetictumordetection_thirty: '胰腺癌',
    Genetictumordetection_thirty_one: '胃肠道间质瘤癌',
    Genetictumordetection_thirty_two: '适用人群',
    Genetictumordetection_thirty_three: '具癌症家族史的高风险人群',
    Genetictumordetection_thirty_four: '具癌症家族史的罹癌患者',
    Genetictumordetection_thirty_five: '罹患两种以上原位癌且发病年龄早于50岁，但没有家族史的罹癌患者',
    Genetictumordetection_thirty_six: '担忧自己携带遗传性肿瘤基因突变的健康人群',
    Genetictumordetection_thirty_eight: '检测优势',
    Genetictumordetection_thirty_nine: '全面筛查',
    Genetictumordetection_fourty: '一次检测，终身受用',
    Genetictumordetection_fourty_one: '精准稳妥',
    Genetictumordetection_fourty_two: '测序准确率高达99.9%，大型数据库支持',
    Genetictumordetection_fourty_three: '专属建议',
    Genetictumordetection_fourty_four: '由专业的遗传咨询顾问进行报告解读',
    Genetictumordetection_fourty_five: '安全可靠',
    Genetictumordetection_fourty_six: '简单抽血即可， 对受测者伤害减至最低',
    Genetictumordetection_fourty_seven: '检测流程',
    Genetictumordetection_fourty_eight: '1. 检测前咨询',
    Genetictumordetection_fourty_nine: '选择适合自己的检测套餐',
    Genetictumordetection_fifty: '2. 采集样本',
    Genetictumordetection_fifty_one: '诊所抽血并将样本送至化验所检测',
    Genetictumordetection_fifty_two: '3. 基因测序分析',
    Genetictumordetection_fifty_three: '以严谨的实验流程完成测序及分析',
    Genetictumordetection_fifty_four: '4. 签发报告',
    Genetictumordetection_fifty_five: '由注册一级化验师签发',
    Genetictumordetection_fifty_six: '5. 解读报告',
    Genetictumordetection_fifty_seven: '对报告解读并进行健康风险管理',
    Genetictumordetection_fifty_eight: '参考文献',
    Genetictumordetection_fifty_nine: '据统计，每年全球',
    Genetictumordetection_sixty: '患癌新症数字约有1,750万',
    Genetictumordetection_sixty_one: ',当中死亡人数高达870万。而癌症患者中，',
    Genetictumordetection_sixty_two: '约5-10%是由遗传性基因变异引起的',
    Genetictumordetection_sixty_three: '如常见的BRCA1/2基因突变会使乳癌、卵巢癌',
    Genetictumordetection_sixty_four: '、大肠癌',
    Genetictumordetection_sixty_five: '及胃癌',
    Genetictumordetection_sixty_six: '罹患风险大幅提高。',

  },
  Talentgenetesting: {
    Talentgenetesting_one: '掌握天赋潜能・达致因材施教',
    Talentgenetesting_two: '基因角度分析特质・度身打造培育建议',
    Talentgenetesting_three: '基因密码千差万别，让我们生而不同',
    Talentgenetesting_four: '子女是上天赐予父母的礼物，每位小朋友都是独一无二的。',
    Talentgenetesting_five: '遗传学上，人与人之间的不同是由基因决定的。最常见的是由单个核苷酸改变而引起的DNA序列的改变，即单核苷酸多态性（Single Nucleotide Polymorphism，简称SNP）。',
    Talentgenetesting_six: '除了如瞳孔颜色等外观表型，我们的天赋潜能、性格发展、智商高低、营养代谢需求等内在情况，某程度上都是由SNP决定的。',
    Talentgenetesting_seven: '如何预测小朋友的天赋潜能？',
    Talentgenetesting_eight: '随着人类基因组测序计划的完成，基因芯片及第二代测序技术的成熟，已经可以让我们解析这些基因密码。',
    Talentgenetesting_nine: '通过大规模的全基因组关联分析研究（Genome-wide association study，GWAS），找出与天赋相关的SNP基因位点。',

    Talentgenetesting_ten: 'genecode天赋基因检测',

    Talentgenetesting_eleven: '以基因组学为本的超全面天赋基因测试',

    Talentgenetesting_twelve: '涵盖天赋，智商，情商，营养健康及健身五大范畴',

    Talentgenetesting_threeteen: '第二代测序技术，基因分型准确率达99.9%',

    Talentgenetesting_fourteen: '集合7大基因组数据库，专注亚洲人数据',

    Talentgenetesting_fiveteen: '非侵入性采样，安全无痛，简单快捷',

    Talentgenetesting_sixteen: '检测详情',

    Talentgenetesting_seventeen: '5大成长因素（70个项目）自由组合',

    Talentgenetesting_eighteen: '天资密码（Talent Code）–6项',

    Talentgenetesting_nineteen: '6种天赋潜能：语言天赋、音乐天赋、数学天赋、阅读天赋、绘画天赋、运动天赋',

    Talentgenetesting_twenty: '情商密码（EQ Code）–14项',

    Talentgenetesting_twenty_one: '5种性格：多情性格、内向性格、冲动性格、随和性格、高度敏感性格',

    Talentgenetesting_twenty_two: '4种能力：坚持力、注意力、领导力、抗压力',

    Talentgenetesting_twenty_three: '3种心向：责任心、好奇心、同理心',

    Talentgenetesting_twenty_four: '2种倾向：焦虑倾向、奖励依赖',

    Talentgenetesting_twenty_five: '智商密码（IQ Code）–14项',

    Talentgenetesting_twenty_six: '8项记忆力：逻辑记忆力、视觉记忆力、空间记忆力、长期记忆力、短期记忆力、工作记忆力、情景记忆力、语音记忆力',

    Talentgenetesting_twenty_seven: '3项智商：晶体智商、流体智商、操作智商',

    Talentgenetesting_twenty_eight: '3项能力：避错能力、认知能力、推理能力',

    Talentgenetesting_twenty_nine: '营养与健康密码（Nutrition & Health Code）–26项',

    Talentgenetesting_thirty: '8种维他命水平：叶酸水平、维他命A水平、维他命B6水平、维他命B12水平、维他命C水平、维他命D及钙水平、维他命E水平、维他命K1水平',

    Talentgenetesting_thirty_one: '6种微量元素水平：锌元素水平、铅元素水平、硒元素水平、铜元素水平、铁元素水平、镁元素水平',

    Talentgenetesting_thirty_two: '2种营养需求：奥米伽3需求、抗氧化物需求',

    Talentgenetesting_thirty_three: '10种健康风险：酒精依赖程度、咖啡耐受性、雀斑风险、青春痘风险、高度近视、牙周炎、过敏性鼻炎、易晒黑倾向、乳糖代谢能力、遗传过敏性湿疹',

    Talentgenetesting_thirty_four: '健身密码（Fitness Code）–10项',

    Talentgenetesting_thirty_five: '10种身体特质：爆发力、耐力、骨骼强壮程度、运动损伤风险、肺功能、运动减肥效果、身高、力量训练的塑形效果、甜味偏好度、饱和脂肪酸对肥胖的影响',

    Talentgenetesting_thirty_six: '权威学术机构科研成果',

    Talentgenetesting_thirty_seven: '哈佛医学院',

    Talentgenetesting_thirty_eight: '身高',

    Talentgenetesting_thirty_nine: '耶鲁大学',

    Talentgenetesting_fourty: '爆发力',

    Talentgenetesting_fourty_one: '牛津大学',

    Talentgenetesting_fourty_two: '语音记忆力',

    Talentgenetesting_fourty_three: '伦敦国王大学',

    Talentgenetesting_fourty_four: '数学天赋',

    Talentgenetesting_fourty_five: '加州大学洛杉矶',

    Talentgenetesting_fourty_six: '坚持力',

    Talentgenetesting_fourty_seven: '伦敦大学学院',

    Talentgenetesting_fourty_eight: '领导力',

    Talentgenetesting_fourty_nine: '针对性培育小孩',

    Talentgenetesting_fifty: 'genecode天赋基因检测帮助你从天赋、智商、情商、营养及运动等五大方面剖析基因是如何影响你的潜能和特质。',

    Talentgenetesting_fifty_one: '因材施教',

    Talentgenetesting_fifty_two: '发掘天资潜能，有针对性地培养',

    Talentgenetesting_fifty_three: '情绪管理',

    Talentgenetesting_fifty_four: '掌握性格发展特质，改善亲子关系',

    Talentgenetesting_fifty_five: '提高效率',

    Talentgenetesting_fifty_six: '找到适合的学习记忆方式',
    Talentgenetesting_fifty_seven: '保障健康',

    Talentgenetesting_fifty_eight: '认识小朋友的营养代谢需求',

    Talentgenetesting_fifty_nine: '善用时间',

    Talentgenetesting_sixty: '为小朋友制定适宜的运动计划',

    Talentgenetesting_sixty_one: '口腔采样',

    Talentgenetesting_sixty_two: '安全无痛',

    Talentgenetesting_sixty_three: '观看视频',


    Talentgenetesting_sixty_four: '专家解读报告',

    Talentgenetesting_sixty_five: '给予合适的跟进建议',

    Talentgenetesting_sixty_six: '印有宝宝照片',

    Talentgenetesting_sixty_seven: '送给孩子最好的礼物',

    Talentgenetesting_sixty_eight: '家长心声',

    Talentgenetesting_sixty_nine: '适用人群',

    Talentgenetesting_seventy: '0-12岁儿童',

    Talentgenetesting_seventy_one: '关注营养、饮食与健康的人士',

    Talentgenetesting_seventy_two: '运动健身爱好者',

    Talentgenetesting_seventy_three: '有家族遗传疾病风险的人士',

    Talentgenetesting_seventy_four: 'genecode与他们的故事',

    Talentgenetesting_seventy_five: '4岁语言小达人',

    Talentgenetesting_seventy_six: 'June是一个十分活泼好动的小女孩，面对全新的社交环境也从不惧怕。3岁时，June随同身为律师的父母搬来香港居住，从未接触过广东话的她，3个月就已经可以对答自如。父母对她的语言天赋很好奇，接受了genecode基因测试后发现，June的确具备很强的语言天赋。但值得注意的是，June的注意力及坚持力就相对较差，因此父母应该着重培养她的专一性，以获得更好的发展。',

    Talentgenetesting_seventy_seven: 'June的故事',

    Talentgenetesting_seventy_eight: '3岁运动小健将',

    Talentgenetesting_seventy_nine: '在完成genecode天资密码测试后，发现活泼的Charlotte在运动方面果然很有天份，只是运动有很多种类，而Charlotte只有3岁，未能自行选择自己喜爱的运动。于是父母随即再让Charlotte进行genecode健身和营养与健康密码测试。报告指出Charlotte的肺功能和耐力优异，适合长跑游泳等。但需要注意Charlotte有易晒黑倾向，需要做足防晒保护皮肤。',

    Talentgenetesting_eighty: 'Charlotte的故事',

    Talentgenetesting_eighty_one: '8岁阅读小能人',

    Talentgenetesting_eighty_two: 'Jacob性格内向，不太喜爱说话。最令爸妈担心的问题是Jacob记忆力好像比同龄的小朋友弱，经常忘记爸妈或老师交待的事情。Jacob妈妈希望透过genecode了解多一些孩子性格和记忆，但结果却令Jacob妈妈震惊。原来Jacob不属于内向性格，并且拥有很高的阅读天赋。只是Jacob的语音记忆力的确比较弱，所以才会记不住爸妈的嘱咐而且不太喜爱说话。',

    Talentgenetesting_eighty_three: 'Jacob的故事',

    Talentgenetesting_eighty_four: '常见问题',

    Talentgenetesting_eighty_five: '怎样透过基因测出宝宝天赋？',

    Talentgenetesting_eighty_six: '天赋基因怎样做？过程安全吗？',

    Talentgenetesting_eighty_seven: '天赋基因准确吗？为甚么有报导说不可信？',

    Talentgenetesting_eighty_eight: '先天遗传和后天培养有什么关系？',

    Talentgenetesting_eighty_nine: '基因检测怎样帮助家长培养子女？',

    Talentgenetesting_ninety: '参考文献',

  },

  YChromosomeDNATest: {
    Title: "Y-染色体母血筛选",
    // P1Title: "孕早期获知胎儿性别",
    P1Title: "孕早期进行Y染色体母血测试",
    P1Detail: "提早干预遗传性疾病",

    P2Title: "胎儿DNA存在于母血之中",
    P2Detail: "怀孕时，胎儿的细胞游离DNA会经由胎盘循环至母亲的血液。",
    P2Detail2: "当怀孕至6-7周时，母亲血液中的胎儿细胞游离DNA量已经足以识别Y染色体的存在。",

    // P3Title: "性染色体 XY = 男",
    // P3Title2: "性染色体 XX = 女",
    P3Title: "",
    P3Title2: "",

    P4Title: "什么是X连锁隐性遗传病？",
    // P4Detail: "孕早期获知胎儿性别可以帮助有",
    // P4Detail_2: "遗传疾病困扰",
    // P4Detail_3: "的家庭提早进行干预。",
    // P4Detail2: "譬如，X连锁隐性遗传病是非常严重的遗传疾病（如",
    P4Detail: "",
    P4Detail_2: "",
    P4Detail_3: "",
    P4Detail2: "X连锁隐性遗传病是非常严重的遗传疾病（如",
    P4Detail2_2: "脆性X综合症",
    P4Detail2_3: "），主要会影响男宝宝健康。如果妈妈是X连锁隐性遗传病的携带者，如果她的后代是儿子，则有50%的机会患病。",
    // P4Detail3: "因此，进行详细的产前遗传咨询，提前了解胎儿性别十分必要。",
    P4Detail3: "因此，进行详细的产前遗传咨询，十分必要。",

    P5Title: "如何进行检测？",
    P5Detail: "从妈妈的血液样本中分离出胎儿游离DNA",
    P5Detail2: "使用特异的引物（primer）去识别其中的Y染色体DNA",
    P5Detail3: "如果存在Y染色体，则目标序列将在引物的指导下扩增并发出荧光，直至被探测到",


    P6Title: "检测方案",
    P6Row1Col1: "检测名称", P6Row1Col2: "检测工作日", P6Row1Col3: "检测样本",
    P6Row2Col1: "7周或以上母血筛选测试", P6Row2Col2: "1个工作日", P6Row2Col3: "6mL EDTA母血x2",
    P6Row3Col1: "7周或以上母血筛选测试（加急）", P6Row3Col2: "6个小时", P6Row3Col3: "6mL EDTA母血x2",
    P6Row4Col1: "6周或以上母血筛选测试", P6Row4Col2: "1个工作日", P6Row4Col3: "6mL EDTA母血x2",
    P6Row5Col1: "6周或以上母血筛选测试（加急）", P6Row5Col2: "6个小时", P6Row5Col3: "6mL EDTA母血x2",

    P7Title: "检测优势",
    P7_1Title: "准确",
    P7_1Detail: "准确率高达99.9%",
    P7_2Title: "早知",
    P7_2Detail: "怀孕6周即可检测",
    P7_3Title: "更快",
    P7_3Detail: "最快6小时出报告",
    P7_4Title: "信心",
    P7_4Detail: "受香港医务化验师管理委员会及注册一级化验师监管",
    P7_5Title: "技术",
    P7_5Detail: "精准及全自动化DNA检测技术",
    P7_6Title: "安全",
    P7_6Detail: "无流产风险",

    P8Title: "适用人群",
    P8_1Detail: "怀孕6周或以上的准妈妈",
    P8_2Detail: "有家族遗传病史（性别相关）的孕妇",

  },
  NonInvasivePrenatalTest: {
    Title: "无创产前检测",
    P1Title: "孕妇首选・为BB健康做好准备",
    P1Detail: "关注染色体异常情况・降低遗传疾病风险",

    P2Title: "您知道染色体疾病吗?",
    P2Detail: "每个正常人体都拥有23对染色体，其中22对属于常染色体，另外1对是决定性别的性染色体。",
    P2Detail2: "当染色体的数目或结构发生异常，如某对染色体不是正常的2条，而变成3条时，就会导致染色体疾病。",
    P2Detail3: "染色体疾病绝大多数发生于受精卵形成时，属于随机突变。因此，",
    P2Detail3_2: "每对父母都有可能诞下患有染色体疾病的小朋友。",
    P2Detail4: "而现今的医学并没有方法治愈，所以选择安全、快速、准确的产前检测，可让准爸妈安心等待BB到来。",

    P3Title: "当染色体发生异常，BB可能出现以下症状︰",
    P3_1Title: "智力障碍",
    P3_2Title: "自闭",
    P3_3Title: "发育迟缓",
    P3_4Title: "畸形",
    P3_5Title: "先天性心脏病",

    P4PreTitle: "新生BB前奏曲",
    P4Title: "无创产前检测",
    P4Detail: "为下一代的健康努力不懈，给准妈妈最强大的支持",

    P5Title: "什么是无创产前检测?",
    P5Detail: "无创产前检测是一项安全、简单、非侵入性的产前检测，能够在怀孕9周起对特定染色体疾病进行筛查。",
    P5Detail2: "孕妇在怀孕期间，胎儿的游离DNA会经过胎盘进入母体的血液系统。无创产前检测只需抽取孕妇静脉血，通过第二代基因测序技术，即可筛查胎儿染色体异常状况。",


    P6Title: "无创产前检测比较",
    P6Detail: "相对于传统侵入性产前诊断方法（羊膜穿刺等），无创产前基因检测是非常安全的产前检测方式，不会导致流产和羊膜腔感染，更大程度降低孕妇产前检测的恐惧感，提高孕妇接受产前染色体异常筛查的意愿。",
    P6Row1Col1: "", P6Row1Col2: "无创产前检测", P6Row1Col3: "早孕期筛选", P6Row1Col4: "中孕期筛选", P6Row1Col5: "羊膜穿刺",
    P6Row2Col1: "怀孕周数", P6Row2Col2: "9周或以上", P6Row2Col3: "11-13周", P6Row2Col4: "16-19周", P6Row2Col5: "16-20周",
    P6Row3Col1: "方法", P6Row3Col2: "分析来自胎盘代表胎儿的游离DNA", P6Row3Col3: "超声波量度胎儿颈皮母血验PAPP-A，hCG", P6Row3Col4: "母血验AFP，hCG，uE3及Inhibin A", P6Row3Col5: "胎儿染色体分析",
    P6Row4Col1: "检出率", P6Row4Col2: "99%以上", P6Row4Col3: "80-90%", P6Row4Col4: "80%", P6Row4Col5: "99%以上",
    P6Row5Col1: "检测方式", P6Row5Col2: "非侵入性检测（抽母血，无流产或感染风险）", P6Row5Col3: "非侵入性检测（抽母血，无流产或感染风险）", P6Row5Col4: "非侵入性检测（抽母血，无流产或感染风险）", P6Row5Col5: "侵入性检测（抽羊水， 有0.5%-1%流产或感染风险）",
    P6Row6Col1: "报告周期", P6Row6Col2: "最快3个工作日", P6Row6Col3: "1-2个工作日", P6Row6Col4: "1-2个工作日", P6Row6Col5: "14-21个工作日",


    P7Title: "适用人群",
    P7_1Detail: "怀孕9周或以上",
    P7_2Detail: "不愿意承担侵入性检测带来的流产风险",
    P7_3Detail: "唐氏综合症筛查结果为高风险",
    P7_4Detail: "多次流产/",
    P7_4Details: "怀有试管婴儿",
    P7_5Detail: "有染色体异常怀孕史",

    P8Title: "检测优势",
    P8_1Title: "安全无创",
    P8_1Detail: "无流产风险",
    P8_2Title: "快捷简易",
    P8_2Detail: "只需孕妇静脉血，约3-7个工作日出报告",
    P8_3Title: "信心保证",
    P8_3Detail: "香港注册医疗化验师签发报告",
    P8_4Title: "早孕检测",
    P8_4Detail: "怀孕9周起即可检测（包括双胞胎）",
    P8_5Title: "全面筛查",
    P8_5Detail: "常染色体三倍体综合症 性染色体异常综合症 微缺失及微重复综合症",

    P9Title: "常见问题",
    P9_1Title: "年龄未满35岁的孕妇也适合做无创产前检测吗？",
    P9_1Detail: "适合。无创产前检测内容包括常染色体三倍体综合症，性染色体异常综合症，及微缺失及微重复综合症。",
    P9_1Detail2: "虽然常染色体三倍体综合症中的唐氏综合症多发于35岁以上的孕妇，但微缺失及微重复综合症与唐氏综合症不同，其发病率不随年纪而增长，任何年纪都有可能患病。因此，即使年龄未满35岁的孕妇都有筛查的必要。",
    P9_2Title: "无创产前检测结果为低风险，是否就意味着无需羊膜穿刺？",
    P9_2Detail: "否。虽然创产前检测具很高的准确性，但结果不用作最终诊断，仅作为高准确性的筛查手段。目前，染色体核型分析依然是产前诊断的金标准。",
    P9_2Detail2: "因此，测结果为低风险者，也不能完全排除胎儿患病的可能性，是否需要羊膜穿刺应遵从医生指示。",
  },
  NonInvasivePrenatalPaternityTest: {
    Title: "无创产前亲子鉴定",
    P1Title: "BB还未出生可做亲子鉴定吗？",
    P1Detail: "可以的！",

    P2Title: "什么是无创产前亲子鉴定？",
    P2Detail: "无创产前亲子鉴定是将母亲血液中提取的胎儿游离DNA，同疑父样本中提取到的DNA进行测序及SNP分型配对，进而分析亲子关系的检测技术。",
    P2Detail2: "由于母血中胎儿游离DNA是片段化的，传统技术很难获取足够有效的位点进行亲子关系判定。而新型SNP分型技术可以应用于小片段DNA，并且对整个人类基因组上大量的SNPs进行分析，结果更准确。",

    P3Title: "检测优势",
    P3_1Title: "安全",
    P3_1Detail: "抽母血即可",
    P3_1DetailHeavy: "无流产风险",
    P3_2Title: "简单",
    P3_2Detail: "无需抽羊水或采集绒毛",
    P3_2DetailHeavy: "只需10mL孕妇静脉血",
    P3_3Title: "早知",
    P3_3Detail: "或以上即可检测",
    P3_3DetailHeavy: "怀孕7周",
    P3_4Title: "准确",
    P3_4Detail: "准确率",
    P3_4DetailHeavy: "超过99.999999%",
    P3_5Title: "快速",
    P3_5Detail: "可知结果",
    P3_5DetailHeavy: "最快5日",
    P3_6Title: "私隐",
    P3_6Detail: "不透露客户任何个人信息",
    P3_6DetailHeavy: "绝对保密",

    P4Title: "接受的鉴定样本",
    P4_1Title: "孕妇",
    P4_1Detail: "静脉血",
    P4_2Title: "疑父",
    P4_2Detail: "静脉血、口腔拭子、指甲、血斑、精斑、5-10根带毛囊的头发",
    P4_2Detail2: "（选其一，建议选择静脉血或口腔拭子）",

    P5Title: "适用人群",
    P5_1Detail: "想确认或寻找胎儿生父的孕妇",
    P5_2Detail: "想确认胎儿是否和自己有亲子关系的男士",
    P5_3Detail: "不愿意入侵性采样的孕妇",
    P5_4Detail: "不适宜接受入侵性采样的孕妇，如羊水过少等",
  },
  vaccinetest: {
    vaccinetest_one: '了解疫苗保护性・免受传染病感染',

    vaccinetest_two: '疫苗并非终身有效・一旦感染可以致命',

    vaccinetest_three: '什么是疫苗？什么是抗体？',

    vaccinetest_four: '疫苗是整个病原体或部份病原体，透过不活化或减轻毒性的过程，加入安定剂、佐剂制造而成。从免疫学的观点来看，所谓疫苗接种，就是将疫苗制剂接种到人体内，藉由免疫系统对外来物的辨认，进行抗体的筛选和制造，以产生对抗该病原体或相似病原体的抗体，使人体获得抵抗某一特定或与疫苗相似病原的免疫力。',

    vaccinetest_five: '注射疫苗并不意味终身保护，主要原因为：',

    vaccinetest_six: '1.疫苗保护率',

    vaccinetest_seven: '「疫苗保护率97%」不是指1人享有97%的保护，而是100人里有3人会有生病的可能！',

    vaccinetest_eight: '2.保护期效',

    vaccinetest_nine: '抗体存在保护期效，大部分疫苗都并非保障终身！',

    vaccinetest_ten: '3.生产质量',

    vaccinetest_eleven: '疫苗生产质量不合格，存放及运输温度不适宜都会造成疫苗无效！',

    vaccinetest_twelve: '4.接种人士',

    vaccinetest_threeteen: '接种人士体质不同，无法激发免疫系统从而造成抗体不足！',

    vaccinetest_fourteen: '检测内容',
    vaccinetest_fiveteen: '甲型肝炎抗体',

    vaccinetest_sixteen: '乙肝病毒表面抗体（定量）',

    vaccinetest_seventeen: '麻疹抗体IgG',

    vaccinetest_eighteen: '流行性腮腺炎抗体IgG',

    vaccinetest_nineteen: '德国麻疹病毒抗体IgG',

    vaccinetest_twenty: '水痘带状疱疹抗体IgG',

    vaccinetest_twenty_one: '破伤风类毒素抗体IgG',

    vaccinetest_twenty_two: '白喉类毒素抗体IgG',

    vaccinetest_twenty_three: '小儿麻痹病毒抗体',

    vaccinetest_twenty_four: '乙型流感嗜血杆菌抗体IgG',

    vaccinetest_twenty_five: '肺炎链球菌抗体IgG',

    vaccinetest_twenty_six: '狂犬病毒抗体',

    vaccinetest_twenty_seven: '检测套餐',

    vaccinetest_twenty_eight: '适用人群',

    vaccinetest_twenty_nine: '儿童（3岁或以上）',

    vaccinetest_thirty: '育龄及怀孕初期夫妇',

    vaccinetest_thirty_one: '很久之前打过或不确定是否打过疫苗人士',

    vaccinetest_thirty_two: '免疫功能不全的患者',

    vaccinetest_thirty_three: '即将前往传染病爆发高危地区的旅客',

    vaccinetest_thirty_four: '香港优生优育指导会建议：',

    vaccinetest_thirty_five: '怀孕前德国麻疹抗体检测若是阴性，应注射疫苗，避免传染给胎儿，导致胎儿先天性畸形。建议注射疫苗后3个月再开始备孕。',

    vaccinetest_thirty_six: '常见问题',

    vaccinetest_thirty_seven: '曾经接受过疫苗接种，抗体检测结果成阴性应该如何处理？',

    vaccinetest_thirty_eight: '不同疫苗的保护率及保护期效有所不同，即使曾经接受过疫苗接种，都可能因为时间过长或自身免疫力差异而失去保护作用。抗体检测结果为阴性者是否需要注射加强针，应该结合疫苗接种史，遵医嘱加以考虑。',

    vaccinetest_thirty_nine: '参考文献',


  },

  stdfastces: {
    stdfastces_one: '在家自我检测性传播疾病',

    stdfastces_two: '定期检查.安心放心',

    stdfastces_three: 'staysafe®安心验四合一性病快速测试',

    stdfastces_four: '筛查四种常见病原体感染',

    stdfastces_five: '爱滋病',

    stdfastces_six: '乙型肝炎',

    stdfastces_seven: '梅毒',

    stdfastces_eight: '阴部疱疹',

    stdfastces_nine: '定期自检，给自己和伴侣一份安心',

    stdfastces_ten: '方便易用',

    stdfastces_eleven: '只需几滴血',

    stdfastces_twelve: '隐私保障',

    stdfastces_threeteen: '在家检测‧免除尴尬',

    stdfastces_fourteen: '快速准确',

    stdfastces_fiveteen: '15分钟‧即知结果',

    stdfastces_sixteen: '如何检测？',

    stdfastces_seventeen: '1.使用微创采血针，挤出少量指尖血',

    stdfastces_eighteen: '2.用移液管将血液滴到样本孔',

    stdfastces_nineteen: '3.待15分钟检视结果',

    stdfastces_twenty: '了解更多',

  },
  news: {
    holiday: '假期安排',
    specialNotice: '特別通知',
  },
  monogenicdisease: {
    monogenicdisease_1: '别让疾病基因遗传给BB',

    monogenicdisease_2: '婚前或备孕夫妇双方均应检测・携手预见未来',

    monogenicdisease_3: '什麽是单基因遗传病？',

    monogenicdisease_4: '单基因遗传病是由单一基因出现异常所导致的疾病。父母将某个基因缺陷传给孩子会导致单基因遗传病。',

    monogenicdisease_5: '世界卫生组织（WHO）官方显示，全球已有超过10,000种单基因遗传病',

    monogenicdisease_6: '单基因遗传病的综合发病率高达1/100，多数会导致患者死亡、畸形及残障',

    monogenicdisease_7: '只有5%的疾病可透过药物治疗维持生命，但终生治疗费用昂贵，生活质量受到严重影响',

    monogenicdisease_8: '隐性单基因遗传病可出现在没有家族史的家庭中。',

    monogenicdisease_9: '常见遗传病症状',

    monogenicdisease_10: '智力障碍',

    monogenicdisease_11: '发育迟缓',

    monogenicdisease_12: '肌肉萎缩',

    monogenicdisease_13: '器官衰竭',

    monogenicdisease_14: '特殊样貌',

    monogenicdisease_15: '严重贫血',

    monogenicdisease_16: '死亡',

    monogenicdisease_17: '隐性遗传病=沉默杀手',

    monogenicdisease_18: '常染色体隐性遗传',

    monogenicdisease_19: '父母均为携带者，后代有25%机会成为患者',

    monogenicdisease_20: '性染色体隐性遗传',

    monogenicdisease_21: '母亲为携带者，儿子有50%机会成为患者',

    monogenicdisease_22: '美国妇产科医学会指引',

    monogenicdisease_23: '所有孕妇都应该进行单基因遗传病携带筛查',

    monogenicdisease_24: '基本筛查：12种常见单基因隐性遗传病',

    monogenicdisease_25: '常染色体隐性遗传',

    monogenicdisease_26: 'α-地中海贫血（HBA1，HBA2）',

    monogenicdisease_27: '携带率︰1/10（中国南方）',

    monogenicdisease_28: '症状︰贫血，需定期输血，严重死亡',

    monogenicdisease_29: 'β-地中海贫血（HBB）',

    monogenicdisease_30: '携带率︰1/36（中国南方）',

    monogenicdisease_31: '症状︰贫血，需定期输血，严重死亡',

    monogenicdisease_32: '苯丙酮尿症（PAH）',

    monogenicdisease_33: '携带率︰1/35',

    monogenicdisease_34: '症状︰智力低下，癫痫，行为异常等',

    monogenicdisease_35: '半乳糖血症（GALT）',

    monogenicdisease_36: '携带率︰未知',

    monogenicdisease_37: '症状︰发育及智能障碍，白内障，肝硬化，严重死亡',

    monogenicdisease_38: '肝豆状核变性症（ATP7B）',

    monogenicdisease_39: '携带率︰1/50',

    monogenicdisease_40: '症状︰肝细胞损害，脑退行性病变，肾脏损伤等',

    monogenicdisease_41: '糖原累积病Ⅱ型（GAA）',

    monogenicdisease_42: '携带率︰1/112',

    monogenicdisease_43: '症状︰多组织器官损害，以心，肝，骨骼肌损害为主',

    monogenicdisease_44: '脊髓性肌肉萎缩症（SMN1）',

    monogenicdisease_45: '携带率︰1/62',

    monogenicdisease_46: '症状︰肌肉逐渐软弱无力，萎缩',

    monogenicdisease_47: '遗传性耳聋（GJB2，SLC26A4）',

    monogenicdisease_48: '携带率︰1/29（GJB2），1/59（SLC26A4）',

    monogenicdisease_49: '症状︰听力缺失，失聪',

    monogenicdisease_50: '囊状纤维化（CFTR）',

    monogenicdisease_51: '携带率︰未知',

    monogenicdisease_52: '症状︰胰腺功能障碍，肺部疾病',

    monogenicdisease_53: 'X染色体隐性遗传',

    monogenicdisease_54: '脆性X综合症（FMR1）',

    monogenicdisease_55: '携带率︰1/250-1/1000（女性）',

    monogenicdisease_56: '症状︰智力迟缓，自闭症',

    monogenicdisease_57: '乙型血友病（F9）',

    monogenicdisease_58: '携带率︰未知',

    monogenicdisease_59: '症状︰多部位出血，关节畸形等',

    monogenicdisease_60: '假肥大性肌营养不良（DMD）',

    monogenicdisease_61: '携带率︰未知',

    monogenicdisease_62: '症状︰步态异常，智力低下',

    monogenicdisease_63: '全面筛查：101种单基因隐性遗传病',

    monogenicdisease_64: '收起',

    monogenicdisease_65: '适用人群',

    monogenicdisease_66: '育龄及怀孕初期夫妇',

    monogenicdisease_67: '有家族疾病史的育龄夫妇',

    monogenicdisease_68: '血缘关系相近的夫妇',

    monogenicdisease_69: '准备人工辅助生殖的夫妇',

    monogenicdisease_70: '案例分析',

    monogenicdisease_71: '个案：中国广东籍女性，孕10周，不明原因流产史。',

    monogenicdisease_72: '经医生建议，夫妇双方进行了地中海贫血基因检测。',

    monogenicdisease_73: '结果显示，',
    monogenicdisease_s: '双方均为地中海贫血携带者。',

    monogenicdisease_74: '张太太在孕18周时抽取羊水进行胎儿地中海贫血基因检测，结果为（--SEA/ααβN/βN），但非重型地中海贫血患者，可继续妊娠。',

    monogenicdisease_75: '检测结果有何帮助？',

    monogenicdisease_76: '阴性',

    monogenicdisease_77: '可以正常进行生育',

    monogenicdisease_78: '阳性',

    monogenicdisease_79: '建议接受遗传咨询，调整生育计划或选择人工受孕',

    monogenicdisease_80: '参考文献',


  },

  Paternitytesting: {
    paternitytesting_1: '安心验证亲缘关系',

    paternitytesting_2: '个人隐私绝对保密',

    paternitytesting_3: '什么是亲子鉴定？',

    paternitytesting_4: '亲子鉴定是通过比对子女和父母的DNA，进而判定亲子关系的检测技术。',

    paternitytesting_5: 'DNA又称遗传“指纹”，可组成一个人的基因和染色体。每个人的DNA都是独一无二的，一半来自爸爸，一半来自妈妈。因此，通过比对父母和小朋友的DNA就可以验证亲子关系。',

    paternitytesting_6: '亲子鉴定的准确率有多少？',

    paternitytesting_7: '亲子鉴定采用短串联重复序列（Short Tandem Repeat，STR）分析技术，通过对比亲代与子代DNA上特异的位点，计算CPI（Combined Paternity Index）指数，从而判断亲子关系，',
    paternitytesting_s: '准确率可达99.999999 %。',

    paternitytesting_8: '可鉴定的关系',

    paternitytesting_9: '父子／父女',

    paternitytesting_10: '母子／母女',

    paternitytesting_11: '兄弟姊妹',

    paternitytesting_12: '（全同胞）',

    paternitytesting_13: '叔侄',

    paternitytesting_14: '接受的样本？',

    paternitytesting_15: '血液',

    paternitytesting_16: '口腔拭子',

    paternitytesting_17: '指甲',

    paternitytesting_18: '血斑／精斑',

    paternitytesting_19: '带毛囊的头发5-10根',

    paternitytesting_20: '检测工作日',

    paternitytesting_21: '3-5个工作日',

    paternitytesting_22: '常见问题',

    paternitytesting_23: '亲子鉴定报告是否保密？',

    paternitytesting_24: '是的，顾客提供的个人资料绝对保密。除非受测者书面同意，亲子鉴定结果绝不向受测者以外的第三者披露。',

    paternitytesting_25: '亲子鉴定测试的准确度有多高？',

    paternitytesting_26: '若符合亲子关系，准确度高达99.99%以上；当结果是排除亲子关系时，则至少会出现两个以上之点位不吻合，而否定亲子关系时准确度是100%。',

    paternitytesting_27: '私人用途和法律用途的亲子鉴定有甚么不同？',

    paternitytesting_28: '准确度无分别。私人用途的报告不能作为法律文件；法律用途的报告可作为各种正式用途，采集样本时，须有第三者在场作证并记录。',
  },
  others: {

    others_1: '为BB买衫买鞋，',

    others_2: '更要给他买不到的健康',

    others_3: '计划BB的出现',

    others_4: '你和伴侣戒掉了咖啡，戒掉了烟酒，调整身体，准备迎接新的生命。',

    others_5: '亲朋好友为你们庆祝，买了BB衫裤、BB金首饰，大家期待着，他有个完美的人生开场。',

    others_6: '但还有一样东西，你是否遗漏了？',

    others_7: '就是要给BB买不到的健康！',

    others_8: 'BB患病是因为你的疏忽吗？',

    others_9: '表面健康的你，可能带给宝贝的疾病风险很多：错过孕前基因筛查、老龄怀孕、携带隐性遗传病基因⋯⋯',

    others_10: '不想留下遗憾？',

    others_11: '就让我们带你一起，为BB的健康做足准备吧！',

    others_12: '不论男宝宝还是女宝宝，都是你的心肝宝贝。',

    others_13: '不用等照超声波，越早检测，更多时间为宝宝到来做好准备。',

    others_14: '关注胎儿染色体情况，降低染色体异常风险，',

    others_15: '包括唐氏综合症（T21）、爱德华氏综合症（T18）、巴陶氏综合症（T13）等。',

    others_16: '亲子鉴定不一定要宝宝出生才可做，只需抽取母血，无流产风险，',

    others_17: '结果同样准确，为你节省等待的烦恼。',

    others_18: '不论亲子或兄弟姐妹，亲子鉴定都可助你确定血浓于水的关系。',

    others_19: '接受多种样本，隐私度高，安全准确。',

    others_20: '关注100+种单基因遗传病携带情况，',

    others_21: '降低下一代死亡、畸形或残障的可能性。',

    others_22: '再早一点，',

    others_23: '生命就再多一点可能性',

    others_24: '三十而立，',

    others_25: '你对未来有许多期待',

    others_26: '组建自己的家庭——温柔的伴侣、稚气的孩子、调皮的宠物。',

    others_27: '你一定想要更多：想看孩子牙牙学语，想参加他的毕业礼；想和爱人慢慢变老，一起散步⋯⋯',

    others_28: '但总有一些隐忧，像藏匿的洪水猛兽，比如癌症。',

    others_29: '早一点行动，',

    others_30: '人生就多一点可能性',

    others_31: '及早筛查癌症风险，及时规避风险、跟进治疗；及早监控癌症复发，避免癌症带来的二次伤害。',

    others_32: '不愿让癌症的威胁破坏你的想象？',

    others_33: '你可以做的，其实有很多！',

    others_34: '关注18种癌症，79种癌症基因，',

    others_35: '提示癌症的遗传风险，预防胜于治疗。',

    others_36: '以崭新ctDNA技术，随时掌握肿瘤动向，',

    others_37: '提早侦测复发，预后更佳。',

    others_38: '保护自己，',

    others_39: '也要保护你爱的人',

    others_40: '你很小心对待BB的身体，',
    others_40s: '想给他最全的保护',

    others_41: 'BB降生以来，带他打疫苗，你从不疏忽，',

    others_42: '但疫苗其实并非终身有效，你又知道吗？',

    others_43: '了解疫苗保护性，免受传染病感染。',

    others_44: '你能做到最浪漫的事，',
    others_44s: '就是和爱人一起保持健康',

    others_45: '和爱人温馨之前，你或许有过各种浪漫幻想⋯⋯',

    others_46: '但除了担心意外怀孕，你可能也担心感染性病！',

    others_47: '在美梦开始之前，或许一份检测可以保护你和伴侣。',

    others_48: '疫苗并非终身有效，一旦感染可以致命，',

    others_49: '检测12种疫苗抗体，了解免疫情况。',

    others_50: '和伴侣亲密接触也有机会患上性传染病，会接触到血液的工作亦要加倍注意！',

    others_51: '为自己为伴侣，请定期检测。',

    others_52: '了解更多人生故事，',

    others_53: '开启全新的生活方式',

    others_54: '你记不记得这些瞬间？',

    others_55: '你获得长跑冠军的时候，你喝酒千杯不倒的时候，',

    others_56: '你接触花生而过敏的时候，你为父亲的心脏病担忧的时候。',

    others_57: '其实你的身体已经',
    others_57s: '写好了这些密码',

    others_58: '你的基因里写着你的天赋密码，你的身体里也藏着致敏原的信号，',

    others_59: '甚至父母和子女的遗传疾病风险也一一记录。',

    others_60: '现在，新的生活方式已逐渐盛行，了解更多人生故事，关心你的健康生活。',

    others_61: '关注5大成长因素，70种天赋潜能。',

    others_62: '掌握宝宝天赋潜能，达致因材施教。',


  },
  use_way: {
    Title: '使用条款',
    Pravicy: '私隐政策',
  },

  Mthfr: {
    Title: '叶酸代谢基因测试',

    P1_Title: "科学补服叶酸，呵护妈妈同BB",
    P1_SubTitle: "你知道需要补叶酸，可是知道补多少吗？",

    P2_Title: "什么是叶酸？",
    P2_Content: "叶酸，又名维他命B 9，是一种水溶性维他命。人体自身无法合成，需通过饮食或叶酸补充剂获得。叶酸和新生儿的神经管发育有很大的关联，若孕妇在怀孕初期无法提供给胎儿足够的叶酸，会增加胎儿神经管畸形的机率，且孕妇自身也容易产生贫血等症状，流产、早产的机率也会增加。",

    P3_Title: "叶酸缺乏的危害",
    P3_Content: "叶酸参与人体的新陈代谢，是合成DNA所必须的元素，也是细胞生长和分裂所必备的物质，更是胚胎发育过程中不可缺少的营养素。因此，对于孕期妇女而言，叶酸的缺乏增加了妊娠期并发症发生的风险、提高了多种不良妊娠结局的发生率。",
    p3_2_Title: "叶酸缺乏可能导致以下风险：",
    P3_2_1_1: "胎儿",
    P3_2_1_2: "神经管畸形、唇裂、先天性心脏病",
    P3_2_2_1: "孕妇",
    P3_2_2_2: "贫血、早产",

    P4_Title: "叶酸过量的危害",
    P4_Content: "叶酸在人体内的吸收和转化能力是有限的，叶酸过量会导致未代谢的叶酸（Unmetabolised Folic Acid ,UFA）在人体内累积从而对人体造成危害。",
    p4_2_Title: "叶酸过量可能导致以下风险：",
    P4_2_1: "掩盖维他命B12缺乏的症状（恶性贫血）",
    P4_2_2: "增加癌症、抑郁、认知障碍等疾病风险",

    P5_Title: "为什么要做叶酸代谢基因检测？",
    P5_Content: "叶酸在人体内必须代谢为5-甲基四氢叶酸才能被有效利用，当MTHFR基因发生突变时，MTHFR酶活性降低，无法有效将叶酸转化为人体可利用的成分，因此MTHFR基因突变的人需要适当增加叶酸的摄入量。",

    // P6_Title: "基因型在亚洲人群中分别所占比例",
    P6_Title: "不同基因型在东亚人群中所占比例",
    // P6_Content: "数据显示，在亚洲人群中，突变体和野生型的比例约是0.3 : 0.7。",
    P6_1_1: "基因位点",
    P6_1_2: "MTHFR-C677T",
    P6_1_3: "MTHFR-A1298C",
    P6_2_1: "基因型",
    P6_2_2: "CC（野生型）；CT（突变杂合体）；TT（突变纯合体）",
    P6_2_3: "AA（野生型）；AC（突变杂合体）；CC（突变纯合体）",

    P7_Title: "检测内容",
    P7_1_1: "基因",
    P7_1_2: "MTHFR",
    P7_1_3: "MTHFR",
    P7_2_1: "位点",
    P7_2_2: "C677T",
    P7_2_3: "A1298C",
    P7_3_1: "基因功能",
    P7_3_2: "编码叶酸代谢中的关键酶，",
    P7_3_3: "维持正常的同型半胱氨酸水平。",

    P8_Title: "科学补充叶酸",
    P8_Content: "通过检测MTHFR基因的2个常见突变位点，可以得知MTHFR叶酸代谢酶的活性，从而科学地补充叶酸。",
    P8_1: "测试位点\t基因型\t类型\t酶活性\t叶酸需求",
    P8_2: "MTHFR-C677T\tCC\t野生型\t正常\t正常",
    P8_3: "MTHFR-C677T\tCT\t突变杂合体\t下降\t偏高",
    P8_4: "MTHFR-C677T\tTT\t突变纯合体\t下降\t偏高",
    P8_5: "MTHFR-A1298C\tAA\t野生型\t正常\t正常",
    P8_6: "MTHFR-A1298C\tAC\t突变杂合体\t下降\t偏高",
    P8_7: "MTHFR-A1298C\tCC\t突变纯合体\t下降\t偏高",
    P8_2_1: "叶酸需求正常",
    P8_2_2: "400微克/天",
    P8_2_3: "叶酸需求偏高",
    P8_2_4: "400-1000微克/天",
    P8_3_1: "备注：",
    P8_3_2: "1. 叶酸可耐受最高摄入量为每日1000微克，超过此摄入量可能会掩盖维他命B12缺乏的症状（恶性贫血）。",
    P8_3_3: "2. 对于有神经管畸形妊娠史的妇女，必须谨遵医生建议进行叶酸的补充。",


    P9_Title: "叶酸补充途径",
    P9_Content: "通过对MTHFR基因及其相关位点的检测，根据个人情况选择叶酸补充途径。",
    P9_Title2: "优势",
    P9_Title3: "劣势",
    P9_1_Title: "食物叶酸",
    P9_1_Title2: "",
    P9_1_1: "天然叶酸；",
    P9_1_2: "无耐受上限；",
    P9_1_3: "不易掩盖VB12缺乏问题。",
    P9_1_4: "不稳定；",
    P9_1_5: "原料经过加工易流失；",
    P9_1_6: "生物利用度低。",
    P9_2_Title: "合成叶酸",
    P9_2_Title2: "",
    P9_2_1: "技术大众；",
    P9_2_2: "成本低廉；",
    P9_2_3: "较为稳定。",
    P9_2_4: "高剂量会掩盖VB12缺乏症状；",
    P9_2_5: "补充过量存在危险；",
    P9_2_6: "生物利用度低。",
    P9_3_Title: "活性叶酸",
    P9_3_Title2: "(L- 5 - M T H F)",
    P9_3_1: "成品稳定；不因未代谢叶酸引起危害；",
    P9_3_1_2: "",
    P9_3_2: "人体可直接吸收利用；生物利用度高；",
    P9_3_3: "不易掩盖VB12缺乏问题。",
    P9_3_4: "需要专利技术生产；",
    P9_3_5: "价格较高。",

    P10_Title: "适用人群",
    P10_1: "备孕或者怀孕中的妇女",
    P10_2: "曾怀有神经管缺陷胎儿的妇女",
    P10_3: "有习惯性流产、早产、曾怀有畸胎的妇女",
    P10_4: "有家族心脏血管病史的孕妇",
    P10_5: "有贫血病史的孕妇",

    P11_Title: "检测流程",
    P11_1: "1. 收集样本",
    P11_2: "2. 核对样本数据",
    P11_3: "3. 提取受测者DNA",
    P11_4: "4. DNA质检",
    // P11_5: "5. 使用PCR进行SNP基因分型",
    P11_5: "5. 进行SNP基因分型",
    P11_6: "6. 数据库自动分析检测结果",
    P11_7: "7. 化验师核查检测结果",
    P11_8: "8. 发送报告",

    P12_1_Title: "样本要求",
    P12_1_1: "6mL静脉血",
    P12_2_Title: "检测周期",
    // P12_2_1: "1个工作日",
    P12_2_1: "5个工作日",

    P13_Title: "参考文献",
    P13_1: "1.\tDivision of Cancer Epidemiology and Genetics, National Cancer Institute.",
    P13_2: "2.\t《围受孕期增补叶酸预防神经管缺陷指南(2017)》",
    P13_3: "3.\tGreenberg J A, etc. Reviews in Obstetrics and Gynecology, 2011, 4(2): 52.",
    P13_4: "4.\tScaglione F, etc. Xenobiotica, 2014, 44(5): 480-488.",
    P13_5: "5.\tCenters for Disease Control and Prevention (2020). Retrieving from https://www.cdc.gov/ncbddd/folicacid/mthfr-gene-and-folic-acid.html.",
    P13_6: "6.\tNational Health Commission of the PRC (WS/T 578.5—2018). Chinese dietary reference intakes—Part 5: Water-soluble vitamin. ",
    P13_7: "7.\tWeisberg I, etc. Molecular genetics and metabolism, 1998, 64(3): 169-172.",
    P13_8: "8.\tRS1801133 RefSNP report - dbSNP - NCBI (2018). National Center for Biotechnology Information. Rechieving from https://www.ncbi.nlm.nih.gov/snp/rs1801133.",
    P13_9: "9.\tRS1801131 RefSNP report - dbSNP - NCBI (2018) National Center for Biotechnology Information. Rechieving from https://www.ncbi.nlm.nih.gov/snp/rs1801131.",
    P13_10: "10.\tLiwinski T, Lang UE. Folate and Its Significance in Depressive Disorders and Suicidality: A Comprehensive Narrative Review. Nutrients. 2023;15(17):3859. Published 2023 Sep 4. doi:10.3390/nu15173859.",
    P13_11: "11.\tMorris MC, Evans DA, Bienias JL, et al. Dietary Folate and Vitamin B12 Intake and Cognitive Decline Among Community-Dwelling Older Persons. Arch Neurol. 2005;62(4):641–645. doi:10.1001/archneur.62.4.641.",
    P13_12: "12.\tPieroth R, Paver S, Day S, Lammersfeld C. Folate and Its Impact on Cancer Risk. Curr Nutr Rep. 2018;7(3):70-84. doi:10.1007/s13668-018-0237-y.",
  }
};


export {

  MessageCh

}



// WEBPACK FOOTER //
// ./src/i18n/lang/cn.js